import {
  MeterframeOpenformComponent
} from '@shared/modals/meterframe/meterframe-openform/meterframe-openform.component';
import { ModalConfig } from '@shared/interfaces/modal/modal-config';

export const meterFrameOpenformModalConfig: ModalConfig = {
  component: MeterframeOpenformComponent,
  title: 'meterFrame.create.title',
  actions: [
    {
      type: 'primary',
      label: 'system.button.create',
      method: 'createMeterFrame'
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true
    },
  ],
}
